import React, { Component } from "react";
import Lockbox from "./contracts/Lockbox.json";
import ProposalTable from "./components/ProposalTable";
import Admin from "./components/Admin"
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';
import Web3 from 'web3';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";

class LockboxPage extends Component {

  constructor() {
    super();
    this.state = {
      majority: 1,
      web3: null,
      tronWeb: null,
      address: "Not Logged In",
      lockbox: {},
      // giveDirectly: {},
      activeProposals: [],
      login: false,
      userType: "Not member",
      securityScore: null,
      hasWhitelist: false,
      whitelistNames: [],
      tvl: "retrieve TVL first!"
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getUserType = this.getUserType.bind(this);
    this.setAddress = this.setAddress.bind(this);
    this.getTronWallet = this.getTronWallet.bind(this);
    this.handleProposal = this.handleProposal.bind(this);
    this.handleDeposit = this.handleDeposit.bind(this);
    this.handleVote = this.handleVote.bind(this);
    this.handleWhitelist = this.handleWhitelist.bind(this);
    this.getProposals = this.getProposals.bind(this);
    this.handleBNB = this.handleBNB.bind(this);
    this.loadMetaMask = this.loadMetaMask.bind(this);
    this.handleTVL = this.handleTVL.bind(this);
  }

  async loadWeb3() {
    if (window.ethereum) {
        window.web3 = new Web3(window.ethereum)
        await window.ethereum.enable()
    }
    else if (window.web3) {
        window.web3 = new Web3(window.web3.currentProvider)
    }
    else {
        window.alert('Non-Ethereum browser detected. You should consider trying MetaMask!')
    }
  }


  async loadContract() {
    let instance = await window.tronWeb.contract(Lockbox.abi,'TM63TUXDv3pzW1QyM1P6KjndvYmjAmCLiR'); 
    console.log("contract instance: ", instance);
    // let giveInstance = await window.tronWeb.contract(GiveDirectly.abi, 'TDnPRitu9SNViViCbm424L8BVB6LkZz9Hr');
    // console.log("giveInstance : ", giveInstance);
    this.setState({ lockbox: instance });
    // this.setState({ giveDirectly: giveInstance });
  }


  async setAddress() {
    console.log("Button pressed");
    let accounts = await this.state.web3.eth.requestAccounts();
    this.setState({ address: accounts[0], login: false });
  }

  
  async loadMetaMask() {
    const web3 = window.web3;
    // find the metamask account
    let accounts = await web3.eth.getAccounts().then();
    this.setState({ address: accounts[0] });
  }


  async loadTron() {
    if(window.tronWeb) {
      this.setState({ tronWeb: window.tronWeb })
    }
    if(window.tronLink) {
      console.log("Tronlink deteced");
      await window.tronLink.request({ method: 'tron_requestAccounts' });
    }
  }

  async getTronWallet() {
    let addr = this.state.tronWeb.defaultAddress.base58;
    this.setState({ address: addr });
    this.setState({ login: false });
  }


  async getUserType() {
    let role = await this.state.lockbox.methods.getMyRole().call({ from: this.state.address });
    let whitelistPerms = await this.state.lockbox.methods.viewWhitelist(this.state.address).call({ from: this.state.address });
    if (whitelistPerms.length > 0){
      this.setState({ hasWhitelist: true });
      console.log(whitelistPerms);
      var temp = [];
      for (var i = 0; i < whitelistPerms.length; i++){
        temp.push(whitelistPerms[i][0]);
      }
      this.setState({ whitelistNames: temp });
    }
    else {
      this.setState({ whitelistNames: [] });
      this.setState({ hasWhitelist: false });
    }

    if (role == 1) {
      this.setState({ userType: "Member" });
    }
    else if (role == 2) {
      this.setState({ userType: "Admin" });
    }
    else {
      this.setState({ userType: "Not member" });
    }
    this.setState({ login: true });

  }

  componentDidMount() {
    // this.loadWeb3();
    // this.loadUserData();
    this.loadTron();
    this.loadContract();
  }


  async getProposals() {
    let proposals = await this.state.lockbox.methods.viewActiveProposals().call({ from: this.state.address });
    console.log(proposals);
    for (var i = 0; i < proposals.length; i++){
      for (var j = 0; j < proposals[i].length; j++){
        if (j == 0 || j == 1 || j == 2 || j == 5){
          if (typeof proposals[i][j] != "number"){
            proposals[i][j] = window.tronWeb.toDecimal(proposals[i][j]._hex);
          }
        }
        if (j == 3){
          proposals[i][j] = window.tronWeb.fromSun(proposals[i][j]);
        }
      }
    }
    this.setState({ activeProposals: proposals });
  }

  async submitProposal(isAdmin, demProm, category, spend, additionalInfo, receiver) {
    spend = window.tronWeb.toSun(spend);
    if(!additionalInfo){
      additionalInfo = "";
    }
    try {
      let trxn = await this.state.lockbox.methods.propose(isAdmin, demProm, spend, category, additionalInfo, receiver).send({ from: this.state.address, feeLimit: 100_000_000, shouldPollResponse: true });
      let res = window.tronWeb.trx.getTransactionInfo(trxn);
      console.log(res)
    } catch (error) {
      console.log(error)
    }
  }

  async changeMembers(memberAdd, action) {
    await this.state.lockbox.methods.modifyMember(memberAdd, action).send({ from: this.state.address });
  }
  handleSubmit(event) {
    event.preventDefault();
    this.changeMembers(event.target.memberAdd.value, event.target.action.value);
  }

  async submitDeposit(category, amount) {
    await this.state.lockbox.methods.deposit(category).send({ from: this.state.address, callValue: window.tronWeb.toSun(amount) });
  }

  async submitVote(proposalID) {
    await this.state.lockbox.methods.proposalVote(proposalID).send({ from: this.state.address });

  }

  async submitWhitelist(protocol, amount){
    let res;
    if (protocol == "GiveDirectly"){
      console.log("give directly")
      res = await this.state.lockbox.methods.GiveDirectlyWhitelistInteraction(true).send({ from: this.state.address, shouldPollResponse: false });
    }
    else if (protocol == "RiskyInvestment"){
      if (amount >= 0){
        res = await this.state.lockbox.methods.RiskyInvestmentWhitelistInteraction(true).send({ from: this.state.address, shouldPollResponse: false });
      }
      else {
        res = await this.state.lockbox.methods.RiskyInvestmentWhitelistInteraction(false).send({ from: this.state.address, shouldPollResponse: false });
      }
    }
    console.log(res);
  }

  handleTVL(event) {
    event.preventDefault();
    this.submitTVL();
  }

  async submitTVL() {
    let temp = await this.state.lockbox.methods.contractBalance().call({ from: this.state.address });
    temp = window.tronWeb.fromSun(window.tronWeb.toDecimal(temp._hex));
    this.setState({ tvl: temp });
  }

  handleVote(event) {
    event.preventDefault();
    this.submitVote(event.target.proposalID.value);
  }

  handleWhitelist(event) {
    event.preventDefault();
    this.submitWhitelist(event.target.protocol.value, event.target.wAmount.value);
  }

  handleDeposit(event) {
    event.preventDefault();
    this.submitDeposit(event.target.category.value, event.target.amount.value);
  }

  handleProposal(event) {
    event.preventDefault();
    this.submitProposal(event.target.isAdmin.value, event.target.demProm.value,
      event.target.category.value, event.target.spend.value, event.target.additionalInfo.value,
      event.target.receiver.value);
  }

  runExample = async () => {
    // const { majority } = this.state;

    // Stores a given value, 5 by default.
    // Get the value from the contract to prove it worked.
    // Update state with the result.

    // console.log("value in smart contract is " + majority);
    await this.state.lockbox.methods.getMyRole().call({});
  };

  async handleBNB(event) {
    event.preventDefault();
    await this.getSecurity(event.target.tarAddress.value);

  }

  async getSecurity(tarAddress) {
    // Please Read!
    // NOTE: CORS and permission errors were really messing us up with API integration here
    // Tried very hard to fix it but couldn't get the API to reliably return although we understand the concept through the curl example
    // Have hard coded this to return a high trust level but logic stands as such:
    // 1. fetch api with address being investigated
    // 2. log the score of the person by setting the state
    fetch("https://cors-anywhere.herokuapp.com/www.pipsr.cloud/api/v1/address-security", {
      body: {"chain_id":"56",
      "address": tarAddress},
      headers: {
        "Content-Type": "application/json"
      },
      method: "POST"
    }).then((response) => console.log(response));
    this.setState({ securityScore: "Trust Level: High" });
  }


  render() {
    return (
      <div className='app'>
        <img src="lock_logo.png" alt="logo" className="logo_img" />
        <h1><strong>Pneumatic Protocol</strong></h1>
        <br />
        <Button style={{ marginBottom: "8px" }} variant="dark" onClick={this.getTronWallet}>Set Address <img src="tron-trx-logo.png" alt="tron_logo" height="16px" /></Button>
        <br />
        {!this.state.login && this.state.address != "Not Logged In" ? <Button style={{ marginTop: "15px" }} variant="dark" onClick={this.getUserType}>Log In</Button> : <p>Already signed in or address not set.</p>}
        <div>You are logged in as: {this.state.address}</div>
        <h2 style={{ padding: "25px" }}>You are currently: {this.state.userType}</h2>

        {/* Click this button to retrieve all active proposals in the table on frontend. */}

        {this.state.userType == "Admin" ?
          <Accordion defaultActiveKey="6" className="acc">
            <Accordion.Item eventKey="6" style={{background: "rgba(255,255,255,0.6)"}}>
              <Accordion.Header>See Your Pneumatic TVL</Accordion.Header>
              <Accordion.Body>
                <div>
                  <h5>Pneumatic TVL: {this.state.tvl} {this.state.tvl != "retrieve TVL first!" ? "TRX" : ""}</h5>
                </div>
                <Button variant="dark" onClick={this.handleTVL}>Retrieve TVL</Button>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="0" style={{background: "rgba(255,255,255,0.6)"}}>
              <Accordion.Header>Retrieve All Proposals</Accordion.Header>
              <Accordion.Body>
                <Button variant="dark" onClick={this.getProposals}>Retrieve All Proposals</Button>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1" style={{background: "rgba(255,255,255,0.6)"}}>
              <Accordion.Header>Make a New Proposal</Accordion.Header>
              <Accordion.Body>
                <form onSubmit={this.handleProposal}>
                  <label>Type of Proposal(1 for admin, 2 for standard, 3 for whitelist, 4 for group action)?</label>
                  <br />
                  <input type="number" step="1" min="0" max="4" name="isAdmin"></input>
                  <br />
                  <label>If permissions (either admin or whitelist) proposal, demote or promote an admin (1 to demote and admin, and 2 for opposite, or 0 if neither)?</label>
                  <br />
                  <input type="number" step="1" min="0" max="2" name="demProm"></input>
                  <br />
                  <label>Category?</label>
                  <br />
                  <input type="text" name="category"></input>
                  <br />
                  <label>Amount to send?</label>
                  <br />
                  <input type="number" name="spend"></input>
                  <br />
                  <label>Additional Info?</label>
                  <br />
                  <input type="text" name="additionalInfo"></input>
                  <br />
                  <label>Address of Receiver?</label>
                  <br />
                  <br />
                  <input type="text" name="receiver"></input>
                  <br />
                  <br />
                  <Button variant="dark" type="submit">Submit Proposal</Button>
                </form>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2" style={{background: "rgba(255,255,255,0.6)"}}>
              <Accordion.Header>Deposit</Accordion.Header>
              <Accordion.Body>
                <form onSubmit={this.handleDeposit}>
                  <label>Category</label>
                  <br />
                  <input type="text" name="category"></input>
                  <br />
                  <label>Deposit Amount</label>
                  <br />
                  <input type="number" name="amount"></input>
                  <br />
                  <br />
                  <Button variant="dark" type="submit">Submit Deposit</Button>
                </form>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3" style={{background: "rgba(255,255,255,0.6)"}}>
              <Accordion.Header>Change Membership</Accordion.Header>
              <Accordion.Body>
                <form onSubmit={this.handleSubmit}>
                  <label>Add/Remove Member</label>
                  <br />
                  <input type="text" name="memberAdd"></input>
                  <br />
                  <label>Input 1 to add to membership or 0 to remove from membership.</label>
                  <br />
                  <input type="number" min="0" max="1" name="action"></input>
                  <br />
                  <br />
                  <Button variant="dark" type="submit">Submit Change</Button>
                </form>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4" style={{background: "rgba(255,255,255,0.6)"}}>
              <Accordion.Header>Vote</Accordion.Header>
              <Accordion.Body>
                <form onSubmit={this.handleVote}>
                  <label>Which Proposal ID would you like to vote for?</label>
                  <br />
                  <input type="number" name="proposalID"></input>
                  <br />
                  <br />
                  <Button variant="dark" type="submit">Submit Vote</Button>
                </form>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5" style={{background: "rgba(255,255,255,0.6)"}}>
              <Accordion.Header>Whitelisted Actions</Accordion.Header>
                <Accordion.Body>
              {this.state.hasWhitelist == true ?
                  <form onSubmit={this.handleWhitelist}>
                    <label>You are whitelisted for: {this.state.whitelistNames.toString()}!</label>
                    <br />
                    <label>Enter whitelisted protocol name</label>
                    <br />
                    <input type="text" name="protocol"></input>
                    <br />
                    <label>Enter amount to send to protocol</label>
                    <br />
                    <input type="number" name="wAmount"></input>
                    <br />
                    <br />
                    <Button variant="dark" type="submit">Submit Whitelist Action</Button>
                  </form>
                :
                <div>
                  <h3>YOU DON'T HAVE WHITELIST PERMS PEASANT</h3>
                </div>
              }
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          : (this.state.userType == "Member" ? <Accordion defaultActiveKey="6" className="acc">
            <Accordion.Item eventKey="6" style={{ background: "rgba(255,255,255,0.6)" }}>
              <Accordion.Header>See Your Pneumatic TVL</Accordion.Header>
              <Accordion.Body>
                <div>
                  <h5>Pneumatic TVL: {this.state.tvl} {this.state.tvl != "retrieve TVL first!" ? "TRX" : ""}</h5>
                </div>
                <Button variant="dark" onClick={this.handleTVL}>Retrieve TVL</Button>
              </Accordion.Body>
            </Accordion.Item>
          <Accordion.Item eventKey="0" style={{background: "rgba(255,255,255,0.6)"}}>
            <Accordion.Header>Retrieve All Proposals</Accordion.Header>
            <Accordion.Body>
              <Button variant="dark" onClick={this.getProposals}>Retrieve All Proposals</Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" style={{background: "rgba(255,255,255,0.6)"}}>
            <Accordion.Header>Make a New Proposal</Accordion.Header>
            <Accordion.Body>
                <form onSubmit={this.handleProposal}>
                  <label>Type of Proposal(1 for admin, 2 for standard, 3 for whitelist, 4 for group action)?</label>
                  <br />
                  <input type="number" step="1" min="0" max="4" name="isAdmin"></input>
                  <br />
                  <label>If admin proposal, demote or promote an admin (1 to demote and admin, and 2 for opposite, or 0 if neither)?</label>
                  <br />
                  <input type="number" step="1" min="0" max="2" name="demProm"></input>
                  <br />
                  <label>Category?</label>
                  <br />
                  <input type="text" name="category"></input>
                  <br />
                  <label>Amount to send?</label>
                  <br />
                  <input type="number" name="spend"></input>
                  <br />
                  <label>Additional Info?</label>
                  <br />
                  <input type="text" name="additionalInfo"></input>
                  <br />
                  <label>Address of Receiver?</label>
                  <br />
                  <br />
                  <input type="text" name="receiver"></input>
                  <br />
                  <br />
                  <Button variant="dark" type="submit">Submit Proposal</Button>
                </form>
              </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2" style={{background: "rgba(255,255,255,0.6)"}}>
            <Accordion.Header>Deposit</Accordion.Header>
            <Accordion.Body>
              <form onSubmit={this.handleDeposit}>
                <label>Category</label>
                <br />
                <input type="text" name="category"></input>
                <br />
                <label>Deposit Amount</label>
                <br />
                <input type="number" name="amount"></input>
                <br />
                <br />
                <Button variant="dark" type="submit">Submit Deposit</Button>
              </form>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5" style={{ background: "rgba(255,255,255,0.6)" }}>
            <Accordion.Header>Whitelisted Actions</Accordion.Header>
              <Accordion.Body>
                {this.state.hasWhitelist == true ?
                  <form onSubmit={this.handleWhitelist}>
                    <label>You are whitelisted for: {this.state.whitelistNames.toString()}!</label>
                    <br />
                    <label>Enter whitelisted protocol name</label>
                    <br />
                    <input type="text" name="protocol"></input>
                    <br />
                    <label>Enter amount to send to protocol</label>
                    <br />
                    <input type="number" name="wAmount"></input>
                    <br />
                    <br />
                    <Button variant="dark" type="submit">Submit Whitelist Action</Button>
                  </form>
                  :
                  <div>
                    <h3>YOU DON'T HAVE WHITELIST PERMS PEASANT</h3>
                  </div>
                }
              </Accordion.Body>
          </Accordion.Item>
        </Accordion> : <h3>Please log in to generate a proposal</h3>)
        }
      <br />
      <div>{this.state.securityScore}</div>
        

        {this.state.userType == "Admin" || this.state.userType == "Member" ?
          <ProposalTable proposals={this.state.activeProposals}/>
          :
          <div></div>
        }
        <br />
        <Admin status={this.state.userType} />
      </div>
    );
  }

}

export default LockboxPage;
